import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { tagPageCategories } from "./components/TagPageSwitcher";
import { FlexBox, useBreakpoint } from "@brg/ui";
import { ContextViewTeachersTab } from "../context/components/contextViewTeachersTab";
import {ProjectsButchController} from "core/controllers/ProjectsButchControllerNew";
import { IDesignerLight } from "shared/common";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { CreateLinkTo } from "shared/constants/linkTo";
import { API, Competition, Endpoints, Project, ProjectAPI, Team } from "@brg/api";
import {useGetTagEditors, useGetTagExperts} from "shared/hooks/useGetTagExperts";
import { useTranslation } from "react-i18next";
import { useCompetitionsByTag } from "shared/hooks/api/useCompetitionsByTag";
import { CompetitionContainer } from "_competition/pages/AllCompetitionsPage/styled";
import { CompetitionCard } from "_competition/pages/AllCompetitionsPage/CompetitionCard";
import { ModerationType } from "../teams/const/ModerationTypes";
import { GridWrapperNew, ProjectsGridNew, TeamGrid } from "shared/components/grids";
import { ComputedTeam, computeTeam } from "shared/helpers/types/computed/ComputedTeam";
import { useGetTeamsByIds } from "shared/hooks/api/useGetTeamsByIds";
import { EmptyCategory } from "shared/components/EmptyCategory/EmptyCategory";
import { LayoutConst, modalControllerSelector } from "core";
import {OtherProductsTitle} from "../Shop/styles";
import {bProfile} from "../../../core/utils/bProfile";
import {ProfileRole, useProfile} from "@brg/auth";
import {HsePolicies} from "../../constants/HsePolicies";
import styled, { useTheme } from "styled-components";
import { LMSCourseDurationTypes } from "../teams/const/LMSCourseTypes";
import ProjectCardNew from "shared/components/projectCard/projectCardNew";
import { computeProject } from "shared/helpers/types/computed/ComputedProject";
import InfiniteScroll from "react-infinite-scroll-component";
import { SkeletonCard } from "shared/components/SkeletonCard/SkeletonCard";
import { ProgressBar } from "shared/icons/Progress";
import { ProjectsCount } from "shared/modals/sendProjects/styles";
import { AppTester, getCurrentContextName } from "supporting";
import { InfinityProjectsActions } from "shared/reducers/InfinityProjectsNew";
import { fetchInfiniteProjects } from "shared/actions/infinityProjectsActionsNew";
import { RectangularButtonFilled } from "shared/components/buttons";

interface IProps {
    id: string,
    category: tagPageCategories;
    filter: any;
    onProjectsLoaded?: (project: Project<'Local'>[]) => void;
    projects?: Project<'Local'>[];
    setProjectCount?: (n:number) => void;
    date: number;
    isModer?: boolean;
    isInfinityNeed?: boolean;
    isTagCategory?: boolean;
    tagIsLoading?: boolean;
    currentTab: string;
    externalPageParam?: boolean;
}

const Wrapper = styled(FlexBox)`
    .grid-w{
        padding: 0 !important;
    }
`
export const PeopleTitle = styled(FlexBox)`
    color: ${({theme}) => theme.designerPage.textColor};
    font-family: Inter;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 40px;
    letter-spacing: -0.02em;
    text-transform: capitalize;

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 23px;
        line-height: 27px;
    }
    
    @media(max-width: ${LayoutConst.screen.s}px) {
        font-size: 20px;
        line-height: 25px;
    }
`
const Title = styled(FlexBox)`
    color: ${({theme}) => theme.designerPage.textColor};
    font-family: Inter;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 40px;
    letter-spacing: -0.02em;
    margin-bottom: 16px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 23px;
        line-height: 27px;
    }
    
    @media(max-width: ${LayoutConst.screen.s}px) {
        font-size: 20px;
        line-height: 25px;
    }
`

const SelectedProjectsBar = styled(FlexBox)`
    height: 75px;
    padding: 16px;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    border-top: 1px solid #E7E7E7;
    background: #F2F2F2;
    align-items: center;
    justify-content: space-between;
    z-index: 1000000;
    margin-top: 20px;
    @media (max-width: ${LayoutConst.screen.mac13}px) {
        height: 65px;
        padding: 10px;
    }
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        background: #FFFFFF;
    }
`;

const RejectSelectedCount= styled(ProjectsCount)`
    font-size: 20px;
    font-weight: 600;
    line-height: 25px;
    letter-spacing: -0.4px;
    color: #151514;

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        display: none;
    }
`;

const RejectSelectedButton = styled.button`
    height: 48px;
    padding: 0px 48px;
    border-radius: 3px;
    border: 1px solid #151514;
    background: transparent;
    color: #151514;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    cursor: pointer;
    letter-spacing: -0.34px;
    
`;
const RejectSelectedButtonMobile = styled(RectangularButtonFilled)`
white-space: nowrap;
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        width: 100%;
        height: 40px !important;
    }
`;

const SelectedProjectsBarContent = styled(FlexBox)`
    width: 1152px;
    margin: 0 auto;
    align-items: center;
    justify-content: space-between;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        width: 888px;
    }

    @media (max-width: 940px) {
        width: 712px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        width: calc(100vw - 20px);
    }
`;

export const TagContent: FC<IProps> = ({ 
    id,
    category, 
    filter,
    date,
    isModer,
    currentTab,
    isInfinityNeed,
    externalPageParam,
    onProjectsLoaded,
    projects,
    isTagCategory,
    tagIsLoading,
    setProjectCount
}) => {
    const history = useHistory();
    const is743 = useBreakpoint(LayoutConst.screen.s -1);
    const is992 = useBreakpoint(LayoutConst.screen.m);
    const {t, i18n} = useTranslation();
    const profile = useProfile();
    const dispatch = useDispatch();
    const { name: currentModalName } = useSelector(modalControllerSelector);
    const isModalOpen = Boolean(currentModalName);
    const infScrollRef = useRef<any>(null);
    const isFr = AppTester.isFr();

    const [educationPage, setEducationPage] = useState(1)
    const [organizationsPage, setOrganizationsPage] = useState(1)
    const [selectedNotModeratedProjectIds, setSelectedNotModeratedProjectIds] = useState<string[]>([]);
    const theme = useTheme();
    

    // console.log('ffdsfsdfsd', currentTab, projects)

    const moderatedTagsByPolicy = (profile?.rolesList || [])
        .filter(x => x.startsWith(`${HsePolicies.tag_ordinal_prefix}`))
        .map(x => x.replace(`${HsePolicies.tag_ordinal_prefix}`, ''))
        .map(x => x.split('_'));
    const expertTagsByPolicy = (profile?.rolesList || [])
        .filter(x => x.startsWith(`${HsePolicies.tag_expert_prefix}`))
        .map(x => x.replace(`${HsePolicies.tag_expert_prefix}`, ''))
        .map(x => x.split('_'));
    const editorTagsByPolicy = (profile?.rolesList || [])
        .filter(x => x.startsWith(`${HsePolicies.tag_editor_prefix}`))
        .map(x => x.replace(`${HsePolicies.tag_editor_prefix}`, ''))
        .map(x => x.split('_'));

    const canSeeTagEditors = useMemo(() => {
        if (![tagPageCategories.experts]?.includes(category)) return false;
        if (profile && bProfile.isModer(profile)) return true;
        if (profile && bProfile.isMiddleModer(profile)) return true;
        if (moderatedTagsByPolicy?.map((i: any) => i[0]).includes(id)) return true;
        if (expertTagsByPolicy?.map((i: any) => i[0]).includes(id)) return true;
        if (editorTagsByPolicy?.map((i: any) => i[0]).includes(id)) return true;
        return false;
    }, [category, profile, moderatedTagsByPolicy, id, expertTagsByPolicy, editorTagsByPolicy])

    const expertsReqDisable = useMemo(
        () => (![tagPageCategories.experts]?.includes(category)) , [category])

    const editorsReqDisable = useMemo(
        () => (![tagPageCategories.experts]?.includes(category)) || !canSeeTagEditors , [category, canSeeTagEditors])

    const competitionReqDisable = useMemo(
        () => (![tagPageCategories.competitions]?.includes(category)) , [category])

    const educationReqDisable = useMemo(
        () => (![tagPageCategories.education]?.includes(category)) , [category])

    const organizationsReqDisable = useMemo(
        () => (![tagPageCategories.organizations]?.includes(category)) , [category])

    const experts = useGetTagExperts(
        id, date, i18n.language, setProjectCount, expertsReqDisable
    )

    const editors = useGetTagEditors(
        id, date, i18n.language, setProjectCount, editorsReqDisable
    )

    const competitions = useCompetitionsByTag(
        { 
            id, 
            projectsFilter: filter?.projectsFilter, 
            ...(!isModer && { ignoredContexts: ['briefs'] }) 
        }, date, i18n.language, setProjectCount, competitionReqDisable 
    )
    const [tags, setTags] = useState()

    async function getTags() {
        return await API.request()
            .endpoint(Endpoints.tagsMnePw)
            .url('/api/tags/GetTagsByFilter')
            .addQuery('groupIds', id)
            .get()
            .send()
            .then((r) => r.json())
            .then((r) => {
                setTags(API.toLang(r, i18n.language))
            })
    }
    useEffect(() => {
        if(!tagIsLoading && isTagCategory){
            getTags()
        }
    }, [tagIsLoading, isTagCategory])

    //@ts-ignore
    const tagsByCategoryEducation = useMemo(() => !!tags?.length ? tags.filter(tag => tag?.isEducationTag) : [], [tags]);
     //@ts-ignore
    const tagsByCategory = useMemo(() => !!tagsByCategoryEducation?.length ? tagsByCategoryEducation.map(tag => tag?.tagId) : [], [tagsByCategoryEducation]);
    
    
    const teamByIdsData = useGetTeamsByIds(
       { 
            lang: i18n.language, 
            tagIds: isTagCategory ? tagsByCategory : [id], 
            moderationTypes: [ModerationType.LMS],
            callback: setProjectCount,
            category: category,
            disable: ![tagPageCategories.education]?.includes(category),
            isTagCategory: isTagCategory,
            page: educationPage
            // limit: 40,
            // offset: 0
        } 
    )
    
    const {resp: courses } = teamByIdsData

    const organizationTeamsByTag = useGetTeamsByIds({
        lang: i18n.language,
        tagIds: [id],
        // moderationTypes: [ModerationType.LMS],
        useTagIdsQuery: true,
        callback: setProjectCount,
        category: category,
        disable: organizationsReqDisable,
        page: organizationsPage,
    })

    const { resp: organizationTeams } = organizationTeamsByTag

    const hasMore: boolean = useMemo(()  => {
        // @ts-ignore
        if (courses?.paging && (courses?.paging?.page < courses?.paging?.pages)) return true
        return false
    }, [courses?.paging]) 

    const hasMoreOrganizations: boolean = useMemo(() => {
        // @ts-ignore paging.page приходит с API
        if (organizationTeams?.paging && (organizationTeams?.paging?.page < organizationTeams?.paging?.pages)) return true
        return false
    }, [organizationTeams?.paging])


    const fetchMoreProjectsNext = useCallback(() => {
        if (hasMore) {
            // console.log('fdsfsdfsdf')
            setEducationPage(educationPage + 1)
        }        
    },[educationPage, hasMore]) 

    const fetchMoreOrganizationsNext = useCallback(() => {
        if (hasMoreOrganizations) {
            setOrganizationsPage(organizationsPage + 1)
        }
    }, [organizationsPage, hasMoreOrganizations])

    // console.log('dataaa',teamByIdsData)

     const ShowMoreButtonOrLoading = useMemo(() => {

        return null
    
        return (
          <FlexBox direction='column' directionMobile='column'>
            <GridWrapperNew mobileColumns={2}>
              {new Array(8).fill('').map((_, index) => (
                  <SkeletonCard key={index}/>
              ))}
            </GridWrapperNew>
            <FlexBox justify="center" offsetBottom={24} offsetTop={32}>
              <ProgressBar 
                text={t('text.loading')} 
                loading={true} 
                color={theme.progressbar.color} 
              />
            </FlexBox>
          </FlexBox>
        )
      }, [t, theme])

    const computeCompetition = useMemo(
        () => ((competitions?.data) || []) as Competition<'Local'>[] , [competitions])

    const computeExperts = useMemo(() => (experts?.data || []) as unknown as IDesignerLight[] , [experts])
    const computeEditors = useMemo(() => (editors?.data || []) as IDesignerLight[] , [editors])

    const [computeCourses, setComputeCourses] = useState<any[]>([])
    const [computeOrganizationTeams, setComputeOrganizationTeams] = useState<any[]>([])

    useEffect(() => {
        setEducationPage(1)
        setOrganizationsPage(1)
        setComputeOrganizationTeams([])
    }, [id])

    useEffect(() => {
        // console.log('computeCourses', courses?.data)
        if (computeCourses.length === courses?.paging.count) {
            return
        }
        //@ts-ignore
        if (educationPage === 1 && courses?.paging.page === 1) {
            setComputeCourses(courses?.data || [])
        } else {
            setComputeCourses([...computeCourses, ...(courses?.data || [])])
        }
    }, [courses])

    useEffect(() => {
        if (computeOrganizationTeams.length === organizationTeams?.paging?.count) {
            return
        }
        //@ts-ignore paging.page приходит с API
        if (organizationsPage === 1 && organizationTeams?.paging?.page === 1) {
            setComputeOrganizationTeams(organizationTeams?.data || [])
        } else {
            setComputeOrganizationTeams([...computeOrganizationTeams, ...(organizationTeams?.data || [])])
        }
    }, [organizationTeams])

    // const computeCourses = useMemo(() => (courses?.data || []) as Team[] , [courses])
    const actualTagsList = useMemo(() => {
        if (isTagCategory) {
            return tagsByCategory
        }
        if (id) {
            return [id]
        }
        return []
    }, [isTagCategory, tagsByCategory, id])

    const filterCourses = {
            projectFilter: 15,
            tagIds: actualTagsList,
            hasRootTeam: true,
            limit: 2,
            projectStatus: 1
        };

    const [isLoading, setIsLoading] = useState(false);
    const [coursesProject, setCoursesProject] = useState<Project<'Local'>[] | undefined>(undefined);

    useEffect(() => {
                // setIsLoading(true);
                if(!!actualTagsList?.length){
                    setIsLoading(true);
                    // @ts-ignore
                    ProjectAPI.GetList(filterCourses).then((r) => r.json()).then((r) => {
                        const localizedValue = API.toLang<Project[]>(r.data, i18n.language);
                        setCoursesProject(localizedValue)
                        setIsLoading(false);
                    })
                }
               

        }, [actualTagsList?.length])
        
    const onDesignerClick = (value: string) => {
        history.push(CreateLinkTo.designer(value))
    };

    const preloadedTab = useMemo(
        () => ([{ path: 'main', contextName: '', filter: { ...(filter?.tagIds && { tagIds: filter?.tagIds }), onlyBooks: '' }, href: null, name: []}]),[filter])

    const isSortedByNotModerated = useMemo(
        () => Boolean(filter?.notModerated),
        [filter?.notModerated]
    );

    const onSelectNotModeratedProject = useCallback((projectId: string) => {
        setSelectedNotModeratedProjectIds((prev) => (
            prev.includes(projectId)
                ? prev.filter((id) => id !== projectId)
                : [...prev, projectId]
        ));
    }, []);

    const onRejectSelectedProjects = useCallback(async () => {
        if (!selectedNotModeratedProjectIds.length) return;
        const context = getCurrentContextName();
        if (!context) return;
        await API.request()
            .endpoint(Endpoints.geograffee)
            .url('/api/Project/UpdateContextsBatch')
            .post()
            .body(
                selectedNotModeratedProjectIds.map((projectId) => ({
                    projectId: projectId,
                    isAgeRestricted: false,
                    contexts: [{
                        context: "hsedesign",
                        operation: 0,
                    }],
                }))
            )
            .send();
        setSelectedNotModeratedProjectIds([]);
        dispatch(InfinityProjectsActions.clearProjects());
        dispatch(InfinityProjectsActions.clearPreloadProjects());
        dispatch(InfinityProjectsActions.clearOffset());
        dispatch(InfinityProjectsActions.setFilter(filter));
        dispatch(fetchInfiniteProjects({
            preload: preloadedTab,
            page: 1,
            currentTab: 'main',
            isTagPage: true,
        }));
    }, [selectedNotModeratedProjectIds, dispatch, filter, preloadedTab]);

    const onApproveSelectedProjects = useCallback(async () => {
        if (!selectedNotModeratedProjectIds.length) return;

        const context = getCurrentContextName();
        if (!context) return;

        await API.request()
            .endpoint(Endpoints.geograffee)
            .url('/api/Project/UpdateContextsBatch')
            .post()
            .body(
                selectedNotModeratedProjectIds.map((projectId) => ({
                    projectId,
                    isAgeRestricted: false,
                    contexts: [{
                        context,
                        operation: 1,
                    }],
                }))
            )
            .send();

        setSelectedNotModeratedProjectIds([]);
        dispatch(InfinityProjectsActions.clearProjects());
        dispatch(InfinityProjectsActions.clearPreloadProjects());
        dispatch(InfinityProjectsActions.clearOffset());
        dispatch(InfinityProjectsActions.setFilter(filter));
        dispatch(fetchInfiniteProjects({
            preload: preloadedTab,
            page: 1,
            currentTab: 'main',
            isTagPage: true,
        }));
    }, [selectedNotModeratedProjectIds, dispatch, filter, preloadedTab]);
    useEffect(() => {
        if (!isSortedByNotModerated && selectedNotModeratedProjectIds.length) {
            setSelectedNotModeratedProjectIds([]);
        }
    }, [isSortedByNotModerated, selectedNotModeratedProjectIds.length]);

    return useMemo(() => {
            if (category === tagPageCategories.experts) {
              return (
                <FlexBox
                    direction={'column'}
                    directionMobile={'column'}
                    width={'100%'}
                    offsetTop={0}
                    offsetTopMobile={0}
                >
                {(!computeExperts?.length && !computeEditors.length) ? (
                    <EmptyCategory text={t(`tag_page.content.empty.${tagPageCategories.experts}`)} />
                ) : (
                    <FlexBox direction="column" directionMobile="column" offsetTop={is743 ? 0 : is992 ? 8 : 24} gy={is743 ? 0 : is992 ? 8 : 24}>
                        <FlexBox direction="column" directionMobile="column" gy={is743 ? 16 : 0}>
                            <PeopleTitle>{t('tag_page.switcher.item.experts')}</PeopleTitle>
                            <ContextViewTeachersTab
                                showOpa
                                teachers={computeExperts}
                                isLoading={false}
                                onDesignerClick={onDesignerClick}
                                isOpaCard
                                pages={experts?.paging?.pages || 0}
                            />
                        </FlexBox>
                        {!!computeEditors.length && <FlexBox direction="column" directionMobile="column" gy={is743 ? 16 : 0}>
                            <PeopleTitle>{t('tag_page.editors_title')}</PeopleTitle>
                            <ContextViewTeachersTab
                                showOpa
                                teachers={computeEditors}
                                isLoading={false}
                                onDesignerClick={onDesignerClick}
                                isOpaCard
                                pages={editors?.paging?.pages || 0}
                            />
                        </FlexBox>}
                    </FlexBox>
                )}
              </FlexBox>
              )
            }

            else if (category === tagPageCategories.competitions) {
                return (
                    <>
                    {!computeCompetition?.length ? (
                        <EmptyCategory text={t(`tag_page.content.empty.${tagPageCategories.competitions}`)} />
                    ) : (
                        <CompetitionContainer isTagPage>
                            {computeCompetition?.map((competition) => {
                                return (
                                    <CompetitionCard
                                        key={competition?.competitionId}
                                        isNewType={competition?.isNewType || true}
                                        competitionProps={competition}
                                        currentTagId={id}
                                        isMainPage
                                        addParams={{ sorting: 1 }}
                                    >
                                        
                                    </CompetitionCard>
                                )
                            })}
                        </CompetitionContainer>
                    )}
                </>
                )
            }

            else if (category === tagPageCategories.education) {
                return (
                    <>
                        {!computeCourses?.length ? (
                            <EmptyCategory text={t(`tag_page.content.empty.${tagPageCategories.education}`)} />
                        ) : (
                        <InfiniteScroll
                            //@ts-ignore
                            dataLength={computeCourses?.length}
                            next={fetchMoreProjectsNext}
                            hasMore={hasMore}
                            initialScrollY={0}
                            scrollThreshold={0.8}
                            loader={ShowMoreButtonOrLoading}
                            ref={infScrollRef}
                        >
                            <FlexBox
                                direction={'column'}
                                directionMobile={'column'}
                                width={'100%'}
                                offsetTop={24}
                            >
                                <TeamGrid
                                    isEditable={false}
                                    //@ts-ignore
                                    teams={computeCourses.map(computeTeam)}
                                    onTeamClick={(team?: ComputedTeam, e?: any) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    window.open(team?.route, '_self');
                                    }}
                                    hasLinks
                                />
                            </FlexBox>
                        </InfiniteScroll>
                        )}
                    </>
                )
            }

            else if (category === tagPageCategories.organizations) {
                return (
                    <>
                        {!computeOrganizationTeams?.length ? (
                            <EmptyCategory text={t(`tag_page.content.empty.${tagPageCategories.organizations}`)} />
                        ) : (
                        <InfiniteScroll
                            //@ts-ignore
                            dataLength={computeOrganizationTeams?.length}
                            next={fetchMoreOrganizationsNext}
                            hasMore={hasMoreOrganizations}
                            initialScrollY={0}
                            scrollThreshold={0.8}
                            loader={ShowMoreButtonOrLoading}
                            ref={infScrollRef}
                        >
                            <FlexBox
                                direction={'column'}
                                directionMobile={'column'}
                                width={'100%'}
                            >
                                <TeamGrid
                                    isEditable={false}
                                    //@ts-ignore
                                    teams={computeOrganizationTeams.map(computeTeam)}
                                    onTeamClick={(team?: ComputedTeam, e?: any) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    window.open(team?.route, '_self');
                                    }}
                                    hasLinks
                                />
                            </FlexBox>
                        </InfiniteScroll>
                        )}
                    </>
                )
            }
            return (
            <FlexBox offsetTop={0} offsetTopMobile={1} direction="column" directionMobile="column" style={{ paddingBottom: isSortedByNotModerated ? 98 : 0 }}>
               <ProjectsButchController
                filter={filter}
                setProjectCount={setProjectCount}
                onProjectsLoaded={onProjectsLoaded}
                onSelect={onSelectNotModeratedProject}
                selectedProjects={selectedNotModeratedProjectIds}
                isInfinityNeed={true}
                date={date}
                //@ts-ignore
                preloadedTabs={preloadedTab}
                courseLoading={isLoading}
                isTagPage
                currentTab={'main'}
                contextName="main"
                />
                {projects?.length === 0 && <EmptyCategory text={t(`tag_page.content.empty.${tagPageCategories.portfolio}`)} />}
                {isSortedByNotModerated && selectedNotModeratedProjectIds.length > 0 && !isModalOpen && (
                    <SelectedProjectsBar>
                        <SelectedProjectsBarContent>
                            <RejectSelectedCount>
                                {t('competition.selected_projects', {count: selectedNotModeratedProjectIds.length})}
                            </RejectSelectedCount>
                            {is743 ? 
                                (
                                <FlexBox direction="row" directionMobile="row" gx={16}>
                                    <RejectSelectedButtonMobile 
                                        type="button"
                                    onClick={onRejectSelectedProjects}>
                                        {`${t('tag_page.content.reject_projects')} (${selectedNotModeratedProjectIds.length})`}
                                    </RejectSelectedButtonMobile>
                                    {isFr && (
                                        <RejectSelectedButtonMobile
                                            type="button"
                                            onClick={onApproveSelectedProjects}>
                                                {`${t('tag_page.content.approve_projects')} (${selectedNotModeratedProjectIds.length})`}
                                        </RejectSelectedButtonMobile>
                                    )}
                                </FlexBox>
                                ) :
                                <FlexBox gx={16} direction="row">
                                    <RejectSelectedButton
                                    type="button"
                                    onClick={onRejectSelectedProjects}>
                                        {t('tag_page.content.reject_projects')}
                                    </RejectSelectedButton>
                                    {isFr && (
                                        <RejectSelectedButton
                                            type="button"
                                            onClick={onApproveSelectedProjects}>
                                                {t('tag_page.content.approve_projects')}
                                        </RejectSelectedButton>
                                    )}
                                </FlexBox>}

                            

                        </SelectedProjectsBarContent>
                    </SelectedProjectsBar>
                )}
           </FlexBox>
            )
          }
    , [
        t,
        is743,
        date,
        filter,
        currentTab,
        externalPageParam,
        computeCompetition,
        category,
        experts,
        computeEditors,
        tagsByCategory?.length,
        editors,
        computeCourses,
        computeOrganizationTeams,
        computeExperts,
        organizationTeams,
        hasMoreOrganizations,
        fetchMoreOrganizationsNext,
        isSortedByNotModerated,
        selectedNotModeratedProjectIds.length,
        onApproveSelectedProjects,
        isInfinityNeed,
        onProjectsLoaded,
        onDesignerClick,
        setProjectCount,
        isModalOpen
    ])
}import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { tagPageCategories } from "./components/TagPageSwitcher";
import { FlexBox, useBreakpoint } from "@brg/ui";
import { ContextViewTeachersTab } from "../context/components/contextViewTeachersTab";
import {ProjectsButchController} from "core/controllers/ProjectsButchControllerNew";
import { IDesignerLight } from "shared/common";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { CreateLinkTo } from "shared/constants/linkTo";
import { API, Competition, Endpoints, Project, ProjectAPI, Team } from "@brg/api";
import {useGetTagEditors, useGetTagExperts} from "shared/hooks/useGetTagExperts";
import { useTranslation } from "react-i18next";
import { useCompetitionsByTag } from "shared/hooks/api/useCompetitionsByTag";
import { CompetitionContainer } from "_competition/pages/AllCompetitionsPage/styled";
import { CompetitionCard } from "_competition/pages/AllCompetitionsPage/CompetitionCard";
import { ModerationType } from "../teams/const/ModerationTypes";
import { GridWrapperNew, ProjectsGridNew, TeamGrid } from "shared/components/grids";
import { ComputedTeam, computeTeam } from "shared/helpers/types/computed/ComputedTeam";
import { useGetTeamsByIds } from "shared/hooks/api/useGetTeamsByIds";
import { EmptyCategory } from "shared/components/EmptyCategory/EmptyCategory";
import { LayoutConst, modalControllerSelector } from "core";
import {OtherProductsTitle} from "../Shop/styles";
import {bProfile} from "../../../core/utils/bProfile";
import {ProfileRole, useProfile} from "@brg/auth";
import {HsePolicies} from "../../constants/HsePolicies";
import styled, { useTheme } from "styled-components";
import { LMSCourseDurationTypes } from "../teams/const/LMSCourseTypes";
import ProjectCardNew from "shared/components/projectCard/projectCardNew";
import { computeProject } from "shared/helpers/types/computed/ComputedProject";
import InfiniteScroll from "react-infinite-scroll-component";
import { SkeletonCard } from "shared/components/SkeletonCard/SkeletonCard";
import { ProgressBar } from "shared/icons/Progress";
import { ProjectsCount } from "shared/modals/sendProjects/styles";
import { AppTester, getCurrentContextName } from "supporting";
import { InfinityProjectsActions } from "shared/reducers/InfinityProjectsNew";
import { fetchInfiniteProjects } from "shared/actions/infinityProjectsActionsNew";
import { RectangularButtonFilled } from "shared/components/buttons";

interface IProps {
    id: string,
    category: tagPageCategories;
    filter: any;
    onProjectsLoaded?: (project: Project<'Local'>[]) => void;
    projects?: Project<'Local'>[];
    setProjectCount?: (n:number) => void;
    date: number;
    isModer?: boolean;
    isInfinityNeed?: boolean;
    isTagCategory?: boolean;
    tagIsLoading?: boolean;
    currentTab: string;
    externalPageParam?: boolean;
}

const Wrapper = styled(FlexBox)`
    .grid-w{
        padding: 0 !important;
    }
`
export const PeopleTitle = styled(FlexBox)`
    color: ${({theme}) => theme.designerPage.textColor};
    font-family: Inter;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 40px;
    letter-spacing: -0.02em;
    text-transform: capitalize;

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 23px;
        line-height: 27px;
    }
    
    @media(max-width: ${LayoutConst.screen.s}px) {
        font-size: 20px;
        line-height: 25px;
    }
`
const Title = styled(FlexBox)`
    color: ${({theme}) => theme.designerPage.textColor};
    font-family: Inter;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 40px;
    letter-spacing: -0.02em;
    margin-bottom: 16px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 23px;
        line-height: 27px;
    }
    
    @media(max-width: ${LayoutConst.screen.s}px) {
        font-size: 20px;
        line-height: 25px;
    }
`

const SelectedProjectsBar = styled(FlexBox)`
    height: 75px;
    padding: 16px;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    border-top: 1px solid #E7E7E7;
    background: #F2F2F2;
    align-items: center;
    justify-content: space-between;
    z-index: 1000000;
    margin-top: 20px;
    @media (max-width: ${LayoutConst.screen.mac13}px) {
        height: 65px;
        padding: 10px;
    }
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        background: #FFFFFF;
    }
`;

const RejectSelectedCount= styled(ProjectsCount)`
    font-size: 20px;
    font-weight: 600;
    line-height: 25px;
    letter-spacing: -0.4px;
    color: #151514;

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        display: none;
    }
`;

const RejectSelectedButton = styled.button`
    height: 48px;
    padding: 0px 48px;
    border-radius: 3px;
    border: 1px solid #151514;
    background: transparent;
    color: #151514;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    cursor: pointer;
    letter-spacing: -0.34px;
    
`;
const RejectSelectedButtonMobile = styled(RectangularButtonFilled)`
white-space: nowrap;
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        width: 100%;
        height: 40px !important;
    }
`;

const SelectedProjectsBarContent = styled(FlexBox)`
    width: 1152px;
    margin: 0 auto;
    align-items: center;
    justify-content: space-between;

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        width: 888px;
    }

    @media (max-width: 940px) {
        width: 712px;
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        width: calc(100vw - 20px);
    }
`;

export const TagContent: FC<IProps> = ({ 
    id,
    category, 
    filter,
    date,
    isModer,
    currentTab,
    isInfinityNeed,
    externalPageParam,
    onProjectsLoaded,
    projects,
    isTagCategory,
    tagIsLoading,
    setProjectCount
}) => {
    const history = useHistory();
    const is743 = useBreakpoint(LayoutConst.screen.s -1);
    const is992 = useBreakpoint(LayoutConst.screen.m);
    const {t, i18n} = useTranslation();
    const profile = useProfile();
    const dispatch = useDispatch();
    const { name: currentModalName } = useSelector(modalControllerSelector);
    const isModalOpen = Boolean(currentModalName);
    const infScrollRef = useRef<any>(null);
    const isFr = AppTester.isFr();

    const [educationPage, setEducationPage] = useState(1)
    const [organizationsPage, setOrganizationsPage] = useState(1)
    const [selectedNotModeratedProjectIds, setSelectedNotModeratedProjectIds] = useState<string[]>([]);
    const theme = useTheme();
    

    // console.log('ffdsfsdfsd', currentTab, projects)

    const moderatedTagsByPolicy = (profile?.rolesList || [])
        .filter(x => x.startsWith(`${HsePolicies.tag_ordinal_prefix}`))
        .map(x => x.replace(`${HsePolicies.tag_ordinal_prefix}`, ''))
        .map(x => x.split('_'));
    const expertTagsByPolicy = (profile?.rolesList || [])
        .filter(x => x.startsWith(`${HsePolicies.tag_expert_prefix}`))
        .map(x => x.replace(`${HsePolicies.tag_expert_prefix}`, ''))
        .map(x => x.split('_'));
    const editorTagsByPolicy = (profile?.rolesList || [])
        .filter(x => x.startsWith(`${HsePolicies.tag_editor_prefix}`))
        .map(x => x.replace(`${HsePolicies.tag_editor_prefix}`, ''))
        .map(x => x.split('_'));

    const canSeeTagEditors = useMemo(() => {
        if (![tagPageCategories.experts]?.includes(category)) return false;
        if (profile && bProfile.isModer(profile)) return true;
        if (profile && bProfile.isMiddleModer(profile)) return true;
        if (moderatedTagsByPolicy?.map((i: any) => i[0]).includes(id)) return true;
        if (expertTagsByPolicy?.map((i: any) => i[0]).includes(id)) return true;
        if (editorTagsByPolicy?.map((i: any) => i[0]).includes(id)) return true;
        return false;
    }, [category, profile, moderatedTagsByPolicy, id, expertTagsByPolicy, editorTagsByPolicy])

    const expertsReqDisable = useMemo(
        () => (![tagPageCategories.experts]?.includes(category)) , [category])

    const editorsReqDisable = useMemo(
        () => (![tagPageCategories.experts]?.includes(category)) || !canSeeTagEditors , [category, canSeeTagEditors])

    const competitionReqDisable = useMemo(
        () => (![tagPageCategories.competitions]?.includes(category)) , [category])

    const educationReqDisable = useMemo(
        () => (![tagPageCategories.education]?.includes(category)) , [category])

    const organizationsReqDisable = useMemo(
        () => (![tagPageCategories.organizations]?.includes(category)) , [category])

    const experts = useGetTagExperts(
        id, date, i18n.language, setProjectCount, expertsReqDisable
    )

    const editors = useGetTagEditors(
        id, date, i18n.language, setProjectCount, editorsReqDisable
    )

    const competitions = useCompetitionsByTag(
        { 
            id, 
            projectsFilter: filter?.projectsFilter, 
            ...(!isModer && { ignoredContexts: ['briefs'] }) 
        }, date, i18n.language, setProjectCount, competitionReqDisable 
    )
    const [tags, setTags] = useState()

    async function getTags() {
        return await API.request()
            .endpoint(Endpoints.tagsMnePw)
            .url('/api/tags/GetTagsByFilter')
            .addQuery('groupIds', id)
            .get()
            .send()
            .then((r) => r.json())
            .then((r) => {
                setTags(API.toLang(r, i18n.language))
            })
    }
    useEffect(() => {
        if(!tagIsLoading && isTagCategory){
            getTags()
        }
    }, [tagIsLoading, isTagCategory])

    //@ts-ignore
    const tagsByCategoryEducation = useMemo(() => !!tags?.length ? tags.filter(tag => tag?.isEducationTag) : [], [tags]);
     //@ts-ignore
    const tagsByCategory = useMemo(() => !!tagsByCategoryEducation?.length ? tagsByCategoryEducation.map(tag => tag?.tagId) : [], [tagsByCategoryEducation]);
    
    
    const teamByIdsData = useGetTeamsByIds(
       { 
            lang: i18n.language, 
            tagIds: isTagCategory ? tagsByCategory : [id], 
            moderationTypes: [ModerationType.LMS],
            callback: setProjectCount,
            category: category,
            disable: ![tagPageCategories.education]?.includes(category),
            isTagCategory: isTagCategory,
            page: educationPage
            // limit: 40,
            // offset: 0
        } 
    )
    
    const {resp: courses } = teamByIdsData

    const organizationTeamsByTag = useGetTeamsByIds({
        lang: i18n.language,
        tagIds: [id],
        // moderationTypes: [ModerationType.LMS],
        useTagIdsQuery: true,
        callback: setProjectCount,
        category: category,
        disable: organizationsReqDisable,
        page: organizationsPage,
    })

    const { resp: organizationTeams } = organizationTeamsByTag

    const hasMore: boolean = useMemo(()  => {
        // @ts-ignore
        if (courses?.paging && (courses?.paging?.page < courses?.paging?.pages)) return true
        return false
    }, [courses?.paging]) 

    const hasMoreOrganizations: boolean = useMemo(() => {
        // @ts-ignore paging.page приходит с API
        if (organizationTeams?.paging && (organizationTeams?.paging?.page < organizationTeams?.paging?.pages)) return true
        return false
    }, [organizationTeams?.paging])


    const fetchMoreProjectsNext = useCallback(() => {
        if (hasMore) {
            // console.log('fdsfsdfsdf')
            setEducationPage(educationPage + 1)
        }        
    },[educationPage, hasMore]) 

    const fetchMoreOrganizationsNext = useCallback(() => {
        if (hasMoreOrganizations) {
            setOrganizationsPage(organizationsPage + 1)
        }
    }, [organizationsPage, hasMoreOrganizations])

    // console.log('dataaa',teamByIdsData)

     const ShowMoreButtonOrLoading = useMemo(() => {

        return null
    
        return (
          <FlexBox direction='column' directionMobile='column'>
            <GridWrapperNew mobileColumns={2}>
              {new Array(8).fill('').map((_, index) => (
                  <SkeletonCard key={index}/>
              ))}
            </GridWrapperNew>
            <FlexBox justify="center" offsetBottom={24} offsetTop={32}>
              <ProgressBar 
                text={t('text.loading')} 
                loading={true} 
                color={theme.progressbar.color} 
              />
            </FlexBox>
          </FlexBox>
        )
      }, [t, theme])

    const computeCompetition = useMemo(
        () => ((competitions?.data) || []) as Competition<'Local'>[] , [competitions])

    const computeExperts = useMemo(() => (experts?.data || []) as unknown as IDesignerLight[] , [experts])
    const computeEditors = useMemo(() => (editors?.data || []) as IDesignerLight[] , [editors])

    const [computeCourses, setComputeCourses] = useState<any[]>([])
    const [computeOrganizationTeams, setComputeOrganizationTeams] = useState<any[]>([])

    useEffect(() => {
        setEducationPage(1)
        setOrganizationsPage(1)
        setComputeOrganizationTeams([])
    }, [id])

    useEffect(() => {
        // console.log('computeCourses', courses?.data)
        if (computeCourses.length === courses?.paging.count) {
            return
        }
        //@ts-ignore
        if (educationPage === 1 && courses?.paging.page === 1) {
            setComputeCourses(courses?.data || [])
        } else {
            setComputeCourses([...computeCourses, ...(courses?.data || [])])
        }
    }, [courses])

    useEffect(() => {
        if (computeOrganizationTeams.length === organizationTeams?.paging?.count) {
            return
        }
        //@ts-ignore paging.page приходит с API
        if (organizationsPage === 1 && organizationTeams?.paging?.page === 1) {
            setComputeOrganizationTeams(organizationTeams?.data || [])
        } else {
            setComputeOrganizationTeams([...computeOrganizationTeams, ...(organizationTeams?.data || [])])
        }
    }, [organizationTeams])

    // const computeCourses = useMemo(() => (courses?.data || []) as Team[] , [courses])
    const actualTagsList = useMemo(() => {
        if (isTagCategory) {
            return tagsByCategory
        }
        if (id) {
            return [id]
        }
        return []
    }, [isTagCategory, tagsByCategory, id])

    const filterCourses = {
            projectFilter: 15,
            tagIds: actualTagsList,
            hasRootTeam: true,
            limit: 2,
            projectStatus: 1
        };

    const [isLoading, setIsLoading] = useState(false);
    const [coursesProject, setCoursesProject] = useState<Project<'Local'>[] | undefined>(undefined);

    useEffect(() => {
                // setIsLoading(true);
                if(!!actualTagsList?.length){
                    setIsLoading(true);
                    // @ts-ignore
                    ProjectAPI.GetList(filterCourses).then((r) => r.json()).then((r) => {
                        const localizedValue = API.toLang<Project[]>(r.data, i18n.language);
                        setCoursesProject(localizedValue)
                        setIsLoading(false);
                    })
                }
               

        }, [actualTagsList?.length])
        
    const onDesignerClick = (value: string) => {
        history.push(CreateLinkTo.designer(value))
    };

    const preloadedTab = useMemo(
        () => ([{ path: 'main', contextName: '', filter: { ...(filter?.tagIds && { tagIds: filter?.tagIds }), onlyBooks: '' }, href: null, name: []}]),[filter])

    const isSortedByNotModerated = useMemo(
        () => Boolean(filter?.notModerated),
        [filter?.notModerated]
    );

    const onSelectNotModeratedProject = useCallback((projectId: string) => {
        setSelectedNotModeratedProjectIds((prev) => (
            prev.includes(projectId)
                ? prev.filter((id) => id !== projectId)
                : [...prev, projectId]
        ));
    }, []);

    const onRejectSelectedProjects = useCallback(async () => {
        if (!selectedNotModeratedProjectIds.length) return;
        const context = getCurrentContextName();
        if (!context) return;
        await API.request()
            .endpoint(Endpoints.geograffee)
            .url('/api/Project/UpdateContextsBatch')
            .post()
            .body(
                selectedNotModeratedProjectIds.map((projectId) => ({
                    projectId: projectId,
                    isAgeRestricted: false,
                    contexts: [{
                        context: "hsedesign",
                        operation: 0,
                    }],
                }))
            )
            .send();
        setSelectedNotModeratedProjectIds([]);
        dispatch(InfinityProjectsActions.clearProjects());
        dispatch(InfinityProjectsActions.clearPreloadProjects());
        dispatch(InfinityProjectsActions.clearOffset());
        dispatch(InfinityProjectsActions.setFilter(filter));
        dispatch(fetchInfiniteProjects({
            preload: preloadedTab,
            page: 1,
            currentTab: 'main',
            isTagPage: true,
        }));
    }, [selectedNotModeratedProjectIds, dispatch, filter, preloadedTab]);

    const onApproveSelectedProjects = useCallback(async () => {
        if (!selectedNotModeratedProjectIds.length) return;

        const context = getCurrentContextName();
        if (!context) return;

        await API.request()
            .endpoint(Endpoints.geograffee)
            .url('/api/Project/UpdateContextsBatch')
            .post()
            .body(
                selectedNotModeratedProjectIds.map((projectId) => ({
                    projectId,
                    isAgeRestricted: false,
                    contexts: [{
                        context,
                        operation: 1,
                    }],
                }))
            )
            .send();

        setSelectedNotModeratedProjectIds([]);
        dispatch(InfinityProjectsActions.clearProjects());
        dispatch(InfinityProjectsActions.clearPreloadProjects());
        dispatch(InfinityProjectsActions.clearOffset());
        dispatch(InfinityProjectsActions.setFilter(filter));
        dispatch(fetchInfiniteProjects({
            preload: preloadedTab,
            page: 1,
            currentTab: 'main',
            isTagPage: true,
        }));
    }, [selectedNotModeratedProjectIds, dispatch, filter, preloadedTab]);
    useEffect(() => {
        if (!isSortedByNotModerated && selectedNotModeratedProjectIds.length) {
            setSelectedNotModeratedProjectIds([]);
        }
    }, [isSortedByNotModerated, selectedNotModeratedProjectIds.length]);

    return useMemo(() => {
            if (category === tagPageCategories.experts) {
              return (
                <FlexBox
                    direction={'column'}
                    directionMobile={'column'}
                    width={'100%'}
                    offsetTop={0}
                    offsetTopMobile={0}
                >
                {(!computeExperts?.length && !computeEditors.length) ? (
                    <EmptyCategory text={t(`tag_page.content.empty.${tagPageCategories.experts}`)} />
                ) : (
                    <FlexBox direction="column" directionMobile="column" offsetTop={is743 ? 0 : is992 ? 8 : 24} gy={is743 ? 0 : is992 ? 8 : 24}>
                        <FlexBox direction="column" directionMobile="column" gy={is743 ? 16 : 0}>
                            <PeopleTitle>{t('tag_page.switcher.item.experts')}</PeopleTitle>
                            <ContextViewTeachersTab
                                showOpa
                                teachers={computeExperts}
                                isLoading={false}
                                onDesignerClick={onDesignerClick}
                                isOpaCard
                                pages={experts?.paging?.pages || 0}
                            />
                        </FlexBox>
                        {!!computeEditors.length && <FlexBox direction="column" directionMobile="column" gy={is743 ? 16 : 0}>
                            <PeopleTitle>{t('tag_page.editors_title')}</PeopleTitle>
                            <ContextViewTeachersTab
                                showOpa
                                teachers={computeEditors}
                                isLoading={false}
                                onDesignerClick={onDesignerClick}
                                isOpaCard
                                pages={editors?.paging?.pages || 0}
                            />
                        </FlexBox>}
                    </FlexBox>
                )}
              </FlexBox>
              )
            }

            else if (category === tagPageCategories.competitions) {
                return (
                    <>
                    {!computeCompetition?.length ? (
                        <EmptyCategory text={t(`tag_page.content.empty.${tagPageCategories.competitions}`)} />
                    ) : (
                        <CompetitionContainer isTagPage>
                            {computeCompetition?.map((competition) => {
                                return (
                                    <CompetitionCard
                                        key={competition?.competitionId}
                                        isNewType={competition?.isNewType || true}
                                        competitionProps={competition}
                                        currentTagId={id}
                                        isMainPage
                                        addParams={{ sorting: 1 }}
                                    >
                                        
                                    </CompetitionCard>
                                )
                            })}
                        </CompetitionContainer>
                    )}
                </>
                )
            }

            else if (category === tagPageCategories.education) {
                return (
                    <>
                        {!computeCourses?.length ? (
                            <EmptyCategory text={t(`tag_page.content.empty.${tagPageCategories.education}`)} />
                        ) : (
                        <InfiniteScroll
                            //@ts-ignore
                            dataLength={computeCourses?.length}
                            next={fetchMoreProjectsNext}
                            hasMore={hasMore}
                            initialScrollY={0}
                            scrollThreshold={0.8}
                            loader={ShowMoreButtonOrLoading}
                            ref={infScrollRef}
                        >
                            <FlexBox
                                direction={'column'}
                                directionMobile={'column'}
                                width={'100%'}
                                offsetTop={24}
                            >
                                <TeamGrid
                                    isEditable={false}
                                    //@ts-ignore
                                    teams={computeCourses.map(computeTeam)}
                                    onTeamClick={(team?: ComputedTeam, e?: any) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    window.open(team?.route, '_self');
                                    }}
                                    hasLinks
                                />
                            </FlexBox>
                        </InfiniteScroll>
                        )}
                    </>
                )
            }

            else if (category === tagPageCategories.organizations) {
                return (
                    <>
                        {!computeOrganizationTeams?.length ? (
                            <EmptyCategory text={t(`tag_page.content.empty.${tagPageCategories.organizations}`)} />
                        ) : (
                        <InfiniteScroll
                            //@ts-ignore
                            dataLength={computeOrganizationTeams?.length}
                            next={fetchMoreOrganizationsNext}
                            hasMore={hasMoreOrganizations}
                            initialScrollY={0}
                            scrollThreshold={0.8}
                            loader={ShowMoreButtonOrLoading}
                            ref={infScrollRef}
                        >
                            <FlexBox
                                direction={'column'}
                                directionMobile={'column'}
                                width={'100%'}
                            >
                                <TeamGrid
                                    isEditable={false}
                                    //@ts-ignore
                                    teams={computeOrganizationTeams.map(computeTeam)}
                                    onTeamClick={(team?: ComputedTeam, e?: any) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    window.open(team?.route, '_self');
                                    }}
                                    hasLinks
                                />
                            </FlexBox>
                        </InfiniteScroll>
                        )}
                    </>
                )
            }
            return (
            <FlexBox offsetTop={0} offsetTopMobile={1} direction="column" directionMobile="column" style={{ paddingBottom: isSortedByNotModerated ? 98 : 0 }}>
               <ProjectsButchController
                filter={filter}
                setProjectCount={setProjectCount}
                onProjectsLoaded={onProjectsLoaded}
                onSelect={onSelectNotModeratedProject}
                selectedProjects={selectedNotModeratedProjectIds}
                isInfinityNeed={true}
                date={date}
                //@ts-ignore
                preloadedTabs={preloadedTab}
                courseLoading={isLoading}
                isTagPage
                currentTab={'main'}
                contextName="main"
                />
                {projects?.length === 0 && <EmptyCategory text={t(`tag_page.content.empty.${tagPageCategories.portfolio}`)} />}
                {isSortedByNotModerated && selectedNotModeratedProjectIds.length > 0 && !isModalOpen && (
                    <SelectedProjectsBar>
                        <SelectedProjectsBarContent>
                            <RejectSelectedCount>
                                {t('competition.selected_projects', {count: selectedNotModeratedProjectIds.length})}
                            </RejectSelectedCount>
                            {is743 ? 
                                (
                                <FlexBox direction="row" directionMobile="row" gx={16}>
                                    <RejectSelectedButtonMobile 
                                        type="button"
                                    onClick={onRejectSelectedProjects}>
                                        {`${t('tag_page.content.reject_projects')} (${selectedNotModeratedProjectIds.length})`}
                                    </RejectSelectedButtonMobile>
                                    {isFr && (
                                        <RejectSelectedButtonMobile
                                            type="button"
                                            onClick={onApproveSelectedProjects}>
                                                {`${t('tag_page.content.approve_projects')} (${selectedNotModeratedProjectIds.length})`}
                                        </RejectSelectedButtonMobile>
                                    )}
                                </FlexBox>
                                ) :
                                <FlexBox gx={16} direction="row">
                                    <RejectSelectedButton
                                    type="button"
                                    onClick={onRejectSelectedProjects}>
                                        {t('tag_page.content.reject_projects')}
                                    </RejectSelectedButton>
                                    {isFr && (
                                        <RejectSelectedButton
                                            type="button"
                                            onClick={onApproveSelectedProjects}>
                                                {t('tag_page.content.approve_projects')}
                                        </RejectSelectedButton>
                                    )}
                                </FlexBox>}

                            

                        </SelectedProjectsBarContent>
                    </SelectedProjectsBar>
                )}
           </FlexBox>
            )
          }
    , [
        t,
        is743,
        date,
        filter,
        currentTab,
        externalPageParam,
        computeCompetition,
        category,
        experts,
        computeEditors,
        tagsByCategory?.length,
        editors,
        computeCourses,
        computeOrganizationTeams,
        computeExperts,
        organizationTeams,
        hasMoreOrganizations,
        fetchMoreOrganizationsNext,
        isSortedByNotModerated,
        selectedNotModeratedProjectIds.length,
        onApproveSelectedProjects,
        isInfinityNeed,
        onProjectsLoaded,
        onDesignerClick,
        setProjectCount,
        isModalOpen
    ])
}